import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { ArrowRight, Home, Building2, Palette, Paintbrush, Wrench, Key, Hammer, Layers } from 'lucide-react';
import { services } from '../data/seoData';

export default function ServicesOverview() {
  const serviceIcons = {
    innenanstrich: Home,
    fassadenarbeiten: Building2,
    tapezierarbeiten: Palette,
    lackierarbeiten: Paintbrush,
    renovierung: Wrench,
    wohnungsuebergabe: Key,
    spachtelarbeiten: Hammer,
    trockenbau: Layers,
  };

  return (
    <>
      <Helmet>
        <title>Unsere Leistungen | FarbWelt Service - Malerarbeiten & mehr</title>
        <meta name="description" content="Alle Malerleistungen von FarbWelt Service: Innenanstrich, Fassadenarbeiten, Tapezieren, Lackieren, Renovierung und mehr. Qualität aus Dormagen für die Region." />
        <link rel="canonical" href="https://www.farbwelt-service.de/leistungen" />
      </Helmet>

      <div className="min-h-screen bg-white">
        {/* Hero */}
        <section className="bg-gradient-to-br from-[#2E2A88] to-[#1e1a5e] text-white py-16 lg:py-24">
          <div className="container mx-auto px-4">
            <nav className="text-sm mb-6 text-white/80">
              <Link to="/" className="hover:text-white">Home</Link>
              <span className="mx-2">/</span>
              <span>Leistungen</span>
            </nav>
            <h1 className="text-4xl md:text-5xl font-bold font-barlow mb-4">
              Unsere Leistungen
            </h1>
            <p className="text-xl text-white/90 max-w-2xl">
              Professionelle Malerarbeiten für jeden Bedarf – von Innenanstrich 
              bis Fassadensanierung. Qualität und Zuverlässigkeit seit Jahren.
            </p>
          </div>
        </section>

        {/* Services Grid */}
        <section className="py-16">
          <div className="container mx-auto px-4">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {Object.values(services).map((service) => {
                const IconComponent = serviceIcons[service.slug] || Paintbrush;
                return (
                  <Card key={service.slug} className="hover:shadow-xl transition-shadow group">
                    <CardContent className="p-8">
                      <div className="w-16 h-16 bg-[#9B1B30]/10 rounded-xl flex items-center justify-center mb-6 group-hover:bg-[#9B1B30] transition-colors">
                        <IconComponent className="w-8 h-8 text-[#9B1B30] group-hover:text-white transition-colors" />
                      </div>
                      <h2 className="text-2xl font-bold font-barlow mb-3">{service.name}</h2>
                      <p className="text-gray-600 mb-4">{service.description}</p>
                      <ul className="space-y-2 mb-6">
                        {service.benefits.map((benefit, idx) => (
                          <li key={idx} className="flex items-start text-sm text-gray-700">
                            <span className="text-[#9B1B30] mr-2">✓</span>
                            {benefit}
                          </li>
                        ))}
                      </ul>
                      <Link to={`/leistungen/${service.slug}`}>
                        <Button variant="outline" className="w-full group-hover:bg-[#9B1B30] group-hover:text-white group-hover:border-[#9B1B30]">
                          Mehr erfahren
                          <ArrowRight className="w-4 h-4 ml-2" />
                        </Button>
                      </Link>
                    </CardContent>
                  </Card>
                );
              })}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-16 bg-[#9B1B30] text-white">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold font-barlow mb-4">
              Haben Sie Fragen zu unseren Leistungen?
            </h2>
            <p className="text-xl text-white/90 mb-8">
              Wir beraten Sie gerne persönlich. Buchen Sie einen kostenlosen Besichtigungstermin.
            </p>
            <Link to="/termin">
              <Button size="lg" className="bg-white text-[#9B1B30] hover:bg-gray-100 px-12">
                Termin buchen
              </Button>
            </Link>
          </div>
        </section>
      </div>
    </>
  );
}
